
    import infoList from './infoList.vue'
    import componentTitle from './componentTitle.vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface State {
        dataList: object[];
        photoList: object[];
        vinCode: string;
        templateCode: string;
        baseInfo:  object[];
        basicItemInfos:  object[];
        configureInfos:  object[];
        sortArr: string[];
        reportMsg: object;
        videoInfo: object[];
    }

    export default defineComponent({
        name: "BaseInfo",
        setup() {
            let state: State = reactive({
                dataList: [],
                photoList: [],
                baseInfo: [],
                vinCode: '',
                templateCode: '',
                basicItemInfos: [],
                configureInfos: [],
                sortArr: ['carRegDate', 'mileage','mileageKilometers', 'vehicleType', 'purpose'],
                reportMsg: {},
                videoInfo: [],
            })
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {templateCode} = query;
            state.templateCode = String(templateCode) || ''
            state.reportMsg = reportMsgUt;
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {basicItemInfos,photoList, vin, configureInfos,videoInfo} = data
                state.dataList = basicItemInfos
                let baseI: any = [];
                for (let i=0;i<basicItemInfos.length;i++) {
                    if (basicItemInfos[i].fieldCode === 'carRegDate' ||
                    basicItemInfos[i].fieldCode === 'mileage' ||
                    basicItemInfos[i].fieldCode === 'mileageKilometers' ||
                    basicItemInfos[i].fieldCode === 'vehicleType' ||
                    basicItemInfos[i].fieldCode === 'purpose') {
                        baseI.push(basicItemInfos[i]);
                    }
                }
                baseI.sort((s, n) => {
                    return state.sortArr.indexOf(s.fieldCode) - state.sortArr.indexOf(n.fieldCode)
                });
                state.baseInfo = baseI;
                state.photoList = photoList;
                state.vinCode = vin;
                state.basicItemInfos = basicItemInfos;
                state.configureInfos = configureInfos;
                state.videoInfo = videoInfo;
                // console.log('vin:', vin);
            })
            return {
                state,
                router,
                store
            }
        },
        components: {
            infoList,
            componentTitle
        },
        methods: {
            goCarInfo () {
                let carInfo = {
                    basicItemInfos: this.state.basicItemInfos,
                    configureInfos: this.state.configureInfos,
                }
                localStorage.setItem('carInfo', JSON.stringify(carInfo));
                this.store.dispatch('savePageScrollTop', window.scrollY);
                this.$router.push('/tocSCJcarInfo');
            },

            goToImgView(photo) {
                this.store.dispatch('savePageScrollTop', window.scrollY);
                if (photo === 'all') {
                    this.router.push({
                        path:'/tocV4PhotoList',
                        query: {
                            photoIndex:0,
                            group: 'defect',
                            isAll: 'total',
                            templateCode: this.state.templateCode
                        }
                    })
                } else {
                    let currentIndex=0;
                    for (let i =0;i<this.state.photoList.length;i++){
                        let item: any = this.state.photoList[i];
                        if (item.photoIdStr === photo.photoIdStr) {
                            currentIndex = i;
                        }
                    }
                    this.router.push({
                        path:'/tocV4PhotoList',
                        query: {
                            photoIndex: currentIndex,
                            group: 'base' ,
                            templateCode: this.state.templateCode,
                        }
                    })
                }
            }
        }
    })
